import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlag24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFlag24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 3a.75.75 0 0 0-1.5 0v18A.75.75 0 0 0 7 21v-6h12.305a1 1 0 0 0 .755-1.656L16.717 9.5l3.343-3.844A1 1 0 0 0 19.305 4H7zm11.208 10.5H7v-8h11.208l-2.623 3.016-.856.984.856.984z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlag24);
